<template>
  <div>
    <div class="tabs-group" role="tablist">
      <button
        class="tab-item"
        type="button"
        role="tab"
        :aria-selected="activeTab === 'makercart-activites'"
        :class="{ active: activeTab === 'makercart-activites' }"
        @click="setActiveTab('makercart-activites')"
      >
        <span class="tab-text">Makercart Activities</span>
      </button>
      <button
        class="tab-item"
        type="button"
        role="tab"
        :aria-selected="activeTab === 'user-generated-resources'"
        :class="{ active: activeTab === 'user-generated-resources' }"
        @click="setActiveTab('user-generated-resources')"
      >
        <span class="tab-text">EdTech Studio Lessons</span>
      </button>
      <button
        class="tab-item"
        type="button"
        role="tab"
        :aria-selected="activeTab === 'favorite-resources'"
        :class="{ active: activeTab === 'favorite-resources' }"
        @click="setActiveTab('favorite-resources')"
      >
        <span class="tab-text">Favorite Resources</span>
      </button>
    </div>

    <div class="content">
      <!-- Warning/Info Box -->
      <div v-if="activeTab === 'user-generated-resources'" class="info-banner">
        <div class="info-banner-content">
          <div class="info-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M6.85638 7.5C7.31398 6.52901 8.54869 5.83333 10 5.83333C11.841 5.83333 13.3334 6.95262 13.3334 8.33333C13.3334 9.49953 12.2687 10.4792 10.8286 10.7555C10.3766 10.8422 10 11.2064 10 11.6667M10 14.1667H10.0083M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                stroke="#3B4648"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p class="info-text">
            Your previously created EdTech Studio lessons will be displayed
            here.
          </p>
        </div>
      </div>
      <div v-else-if="activeTab === 'makercart-activites'" class="info-banner">
        <div class="info-banner-content">
          <div class="info-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M6.85638 7.5C7.31398 6.52901 8.54869 5.83333 10 5.83333C11.841 5.83333 13.3334 6.95262 13.3334 8.33333C13.3334 9.49953 12.2687 10.4792 10.8286 10.7555C10.3766 10.8422 10 11.2064 10 11.6667M10 14.1667H10.0083M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                stroke="#3B4648"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p class="info-text">
            Your purchased Makercart activities will appear here for easy
            access.
          </p>
        </div>
      </div>
      <div v-else-if="activeTab === 'favorite-resources'" class="info-banner">
        <div class="info-banner-content">
          <div class="info-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M6.85638 7.5C7.31398 6.52901 8.54869 5.83333 10 5.83333C11.841 5.83333 13.3334 6.95262 13.3334 8.33333C13.3334 9.49953 12.2687 10.4792 10.8286 10.7555C10.3766 10.8422 10 11.2064 10 11.6667M10 14.1667H10.0083M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                stroke="#3B4648"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p class="info-text">
            All the resources you have previously saved from lesson library.
          </p>
        </div>
      </div>
      <!-- STEM Activities Tab -->
      <div v-if="activeTab === 'makercart-activites'">
        <LoadingState
          v-if="isLoading"
          message="Loading STEM Activities..."
          minHeight="200px"
        />
        <div v-else>
          <div
            v-if="stemActivities && stemActivities.length === 0"
            class="no-data-message"
          >
            <p>
              You do not have any Makercart Activities assigned to your school.
              <br />Having trouble? Ensure your School is set correctly in your
              Profile Page, or email
              <a href="mailto:hello@eddy4teachers.com"
                >hello@eddy4teachers.com</a
              >
              for help
            </p>
          </div>
          <template v-else>
            <div class="activities-wrapper">
              <template
                v-for="(activity, index) in stemActivities"
                :key="index"
              >
                <STEMActivityCard
                  :activity="activity"
                  @updateVisibilityModalMakerCartDetail="
                    updateVisibilityModalMakerCartDetail
                  "
                />
                <div
                  v-if="index < stemActivities.length - 1"
                  class="card-divider"
                ></div>
              </template>
            </div>
          </template>
          <!-- Pagination Controls -->
          <div v-if="totalPages > 1" class="pagination-controls mb-5">
            <button
              type="button"
              class="pagination-nav-btn"
              aria-label="Previous page"
              @click="setCurrentPage(currentPage - 1)"
              :disabled="currentPage === 1"
            >
              <img
                src="/images/chinaus/vector-right.svg"
                class="mr-2"
                alt=""
                aria-hidden="true"
              />
            </button>
            <button
              v-for="page in pagesToShow"
              :key="page"
              @click="setCurrentPage(page)"
              :class="{ 'page-active': page === currentPage }"
            >
              {{ page }}
            </button>
            <button
              type="button"
              class="pagination-nav-btn"
              aria-label="Next page"
              @click="setCurrentPage(currentPage + 1)"
              :disabled="currentPage === totalPages"
            >
              <img
                src="/images/chinaus/vector-left.svg"
                class="ml-2"
                alt=""
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
      </div>

      <!-- User Generated Resources Tab -->
      <div v-if="activeTab === 'user-generated-resources'">
        <LoadingState
          v-if="isLoading"
          message="Loading User Generated Resources..."
          minHeight="200px"
        />
        <div v-else>
          <div
            v-if="userGeneratedResources && userGeneratedResources.length === 0"
            class="no-data-message"
          >
            <p>No User Generated Resources available.</p>
          </div>
          <div v-else class="resources-wrapper">
            <UserGeneratedResourceCard
              v-for="(resource, index) in userGeneratedResources"
              :key="index"
              :resource="resource"
              @like="likeLessonPackage"
            />
            <!-- Pagination Controls -->
            <div v-if="totalPages > 1" class="pagination-controls mb-5">
              <button
                type="button"
                class="pagination-nav-btn"
                aria-label="Previous page"
                @click="setCurrentPage(currentPage - 1)"
                :disabled="currentPage === 1"
              >
                <img
                  src="/images/chinaus/vector-right.svg"
                  class="mr-2"
                  alt=""
                  aria-hidden="true"
                />
              </button>
              <button
                v-for="page in pagesToShow"
                :key="page"
                @click="setCurrentPage(page)"
                :class="{ 'page-active': page === currentPage }"
              >
                {{ page }}
              </button>
              <button
                type="button"
                class="pagination-nav-btn"
                aria-label="Next page"
                @click="setCurrentPage(currentPage + 1)"
                :disabled="currentPage === totalPages"
              >
                <img
                  src="/images/chinaus/vector-left.svg"
                  class="ml-2"
                  alt=""
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Favorite Resources Tab -->
      <div v-if="activeTab === 'favorite-resources'">
        <LoadingState
          v-if="isLoading"
          message="Loading Favorite Resources..."
          minHeight="200px"
        />
        <div v-else>
          <div
            v-if="userGeneratedResources && userGeneratedResources.length === 0"
            class="no-data-message"
          >
            <p>No Favorite Resources available.</p>
          </div>
          <div v-else class="resources-wrapper">
            <FavoriteResourceCard
              v-for="(favorite, index) in userGeneratedResources"
              :key="index"
              :favorite="favorite"
              @like="likeLessonPackage"
              @like-stem-studio="likeStemStudio"
              @updateVisibilityModalMakerCartDetail="
                updateVisibilityModalMakerCartDetail
              "
            />
            <!-- Pagination Controls -->
            <div v-if="totalPages > 1" class="pagination-controls mb-5">
              <button
                type="button"
                class="pagination-nav-btn"
                aria-label="Previous page"
                @click="setCurrentPage(currentPage - 1)"
                :disabled="currentPage === 1"
              >
                <img
                  src="/images/chinaus/vector-right.svg"
                  class="mr-2"
                  alt=""
                  aria-hidden="true"
                />
              </button>
              <button
                v-for="page in pagesToShow"
                :key="page"
                @click="setCurrentPage(page)"
                :class="{ 'page-active': page === currentPage }"
              >
                {{ page }}
              </button>
              <button
                type="button"
                class="pagination-nav-btn"
                aria-label="Next page"
                @click="setCurrentPage(currentPage + 1)"
                :disabled="currentPage === totalPages"
              >
                <img
                  src="/images/chinaus/vector-left.svg"
                  class="ml-2"
                  alt=""
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <MakerCartDetail ref="makerCartDetail" mode="detail"></MakerCartDetail>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserService from "@/services/userService";
import cookiesService from "@/services/cookiesService";
import StemStudioService from "@/services/stemStudioService"; // Import service untuk STEM activities
import STEMActivityCard from "./STEMActivityCard.vue"; // Import STEM Activity Card
import UserGeneratedResourceCard from "./UserGeneratedResourceCard.vue"; // Import User Generated Resource Card
import FavoriteResourceCard from "./FavoriteResourceCard.vue"; // Import Favorite Resource Card
import MakerCartDetail from "@/components/maker-cart/MakerCartDetail.vue";
import { useStore } from "vuex";
import makercartActivityService from "@/services/makercartActivityService";
import lessonPackageService from "@/services/lessonPackageService";
import LoadingState from "@/components/common/LoadingState.vue";

const route = useRoute();
const router = useRouter();

const activeTab = ref("user-generated-resources");
const isLoading = ref(false);
const stemActivities = ref([]);
const userGeneratedResources = ref([]);
const currentPage = ref(1); // Set current page
const totalPages = ref(0);
const makerCartDetail = ref(null);
const store = useStore();

const user = computed(() => store.state.user);

// Helper function to load data for a specific tab
const loadDataForTab = (tabName) => {
  if (tabName === "user-generated-resources") {
    getProfileLessonPackages(); // Fetch user-generated resources
  } else if (tabName === "favorite-resources") {
    getFavoriteResources(currentPage.value, 5); // Fetch favorite resources
  } else if (tabName === "makercart-activites") {
    getStemActivities(1, 5); // Fetch STEM activities
  }
};

// Watch for route query changes
watch(
  () => route.query,
  (newQuery) => {
    const newTab = newQuery.tab;
    const newPage = newQuery.page ? parseInt(newQuery.page) : 1;

    if (
      newTab &&
      [
        "makercart-activites",
        "user-generated-resources",
        "favorite-resources",
      ].includes(newTab)
    ) {
      // Only update if tab actually changed
      if (activeTab.value !== newTab) {
        activeTab.value = newTab;
        currentPage.value = 1; // Reset page when changing tabs
        loadDataForTab(newTab);
      } else if (currentPage.value !== newPage) {
        // Only page changed
        currentPage.value = newPage;
        loadDataForTab(newTab);
      }
    }
  },
  { immediate: true, deep: true }
);

onMounted(async () => {
  // Set initial tab from route query or default
  const tabFromQuery = route.query.tab;
  const pageFromQuery = route.query.page ? parseInt(route.query.page) : 1;

  if (
    tabFromQuery &&
    [
      "makercart-activites",
      "user-generated-resources",
      "favorite-resources",
    ].includes(tabFromQuery)
  ) {
    activeTab.value = tabFromQuery;
  } else {
    activeTab.value = "user-generated-resources";
    // Update URL with default tab
    router.push({
      path: route.path,
      query: { ...route.query, tab: "user-generated-resources" },
    });
  }

  // Set initial page
  currentPage.value = pageFromQuery;

  // Load initial data
  loadDataForTab(activeTab.value);
});

// Function to fetch STEM activities
async function getStemActivities(page = 1, limit = 5) {
  try {
    isLoading.value = true;
    const response = await makercartActivityService.getPrivateEducatorGuides({
      page,
      limit,
    });
    if (response.status === 200) {
      stemActivities.value = response.data.data.rows;
      totalPages.value = response.data.data.total_pages;
    } else {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.error("error", error);
  } finally {
    isLoading.value = false;
  }
}

// Function to fetch profile lesson packages with pagination
async function getProfileLessonPackages() {
  try {
    isLoading.value = true;
    const authToken = await cookiesService.getCookie("authToken");
    if (!authToken) {
      throw new Error("Auth token is not available");
    }

    const response = await lessonPackageService.getMyResources(
      user.value?.email
    );
    if (response.status === 200) {
      userGeneratedResources.value = response.data.data;
    } else {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.error("error", error);
  } finally {
    isLoading.value = false;
  }
}

// Function to fetch favorite resources with pagination
async function getFavoriteResources(page = 1, limit = 5) {
  try {
    isLoading.value = true;
    const response = await UserService.getLikedResources(page, limit);
    if (response.status === 200) {
      const rows = response.data.data.rows || [];
      // Map rows to match FavoriteResourceCard expectations
      userGeneratedResources.value = rows.map((row) => ({
        ...row,
        title: row.activity_name,
        short_description: row.activity_description,
        thumbnail: row.image_thumbnail?.[0]?.thumbnails?.large?.url || null,
      }));
      totalPages.value = response.data.data.total_pages;
    } else {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.error("error", error);
  } finally {
    isLoading.value = false;
  }
}

// Function to set the active tab and reset pagination
const setActiveTab = (tabName) => {
  // Update URL with new tab parameter
  router.push({
    path: route.path,
    query: { ...route.query, tab: tabName },
  });

  // Note: The actual tab switching and data loading will be handled by the watcher
};

// Function to set the current page and reload data
const setCurrentPage = (page) => {
  if (page !== currentPage.value && page > 0 && page <= totalPages.value) {
    currentPage.value = page;

    // Update URL with page parameter
    router.push({
      path: route.path,
      query: { ...route.query, tab: activeTab.value, page: page },
    });

    // Load data for current page
    if (activeTab.value === "user-generated-resources") {
      getProfileLessonPackages();
    } else if (activeTab.value === "favorite-resources") {
      getFavoriteResources();
    } else if (activeTab.value === "makercart-activites") {
      getStemActivities(page, 5);
    }
  }
};

// Computed property to generate pagination buttons
const pagesToShow = computed(() => {
  const pages = [];
  for (let i = 1; i <= totalPages.value; i++) {
    pages.push(i);
  }
  return pages;
});

// eslint-disable-next-line
const likeLessonPackage = async (id) => {
  try {
    isLoading.value = true; // Set isLoading menjadi true ketika mulai request
    const authToken = await cookiesService.getCookie("authToken");
    if (!authToken) {
      throw new Error("Auth token is not available");
    }

    const response = await UserService.likeLessonPackage(authToken.token, id);
    if (response.status === 200) {
      setActiveTab("favorite-resources");
    } else {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (error) {
    console.error("error", error);
  } finally {
    isLoading.value = false; // Set isLoading menjadi false setelah request selesai
  }
};

const likeStemStudio = async (id) => {
  try {
    const response = await StemStudioService.likeMakercart(id);
    if (response.status === 200) {
      setActiveTab("favorite-resources");
    } else {
      throw new Error(`Request failed with status ${response.status}`);
    }
  } catch (err) {
    console.error("Error posting cart data:", err.message);
  }
};

function updateVisibilityModalMakerCartDetail({
  visible,
  id,
  stem_makercart_order_id,
}) {
  makerCartDetail.value.updateVisibilityModal(
    visible,
    id,
    stem_makercart_order_id
  );
}
</script>

<style scoped>
.tabs-group {
  display: flex;
  position: relative;
  border-bottom: 1px solid #d8dae5;
  margin-bottom: 24px;
}

.tab-text {
  font-family: "League Spartan", sans-serif;
  font-size: var(--fs-big);
  line-height: 24px;
  letter-spacing: 0.024px;
  color: #3b4648;
  font-weight: 400;
  white-space: nowrap;
  margin: 0;
}

.tab-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  cursor: pointer;
  position: relative;
  gap: 8px;
  background: transparent;
  border: none;
  appearance: none;
  font-family: inherit;
}

.tab-item.active .tab-text {
  color: #e00069;
  font-weight: 700;
}

.pagination-nav-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-banner {
  background-color: #fef7ee;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.info-banner-content {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
}

.info-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-data-message {
  text-align: center;
}

.info-text {
  font-family: "League Spartan", sans-serif;
  font-weight: 400;
  font-size: var(--fs-big);
  line-height: 24px;
  letter-spacing: 0.024px;
  color: #3b4648;
  margin: 0;
  flex: 1;
}

.activity-card,
.resource-card,
.favorite-card {
  border: 1px solid #ddd;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
}

.activity-card h3,
.resource-card h3,
.favorite-card h3 {
  margin-bottom: 8px;
}

.resources-wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.activities-wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.card-divider {
  height: 0;
  width: 100%;
  margin: 0;
  border: none;
  background-image: url("data:image/svg+xml,%3Csvg width='100%25' height='2' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 1 L100%25 1' stroke='%23d8dae5' stroke-width='1' stroke-dasharray='4 4'/%3E%3C/svg%3E");
  background-repeat: repeat-x;
  background-position: center;
}

/* Mobile Styles */
@media (max-width: 768px) {
  .tabs-group {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    scroll-behavior: smooth;
  }

  .tabs-group::-webkit-scrollbar {
    display: none;
  }

  .tab-item {
    flex-shrink: 0;
    min-width: fit-content;
    padding: 16px 20px;
  }

  .info-text {
    font-size: var(--fs-small);
  }
}
</style>
